import { c as _c } from "react/compiler-runtime";
import axios from "axios";
import { cmsService, type CmsPage } from "@/services";
type Props = {
  slug: string;
  fallbackTitle: string;
  fallbackHtml: string;
};
async function fetchPage(slug: string): Promise<{
  status: "ok";
  page: CmsPage;
} | {
  status: "missing";
} | {
  status: "error";
}> {
  try {
    const page = await cmsService.getPage(slug);
    return {
      status: "ok",
      page
    };
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 404) {
      return {
        status: "missing"
      };
    }
    return {
      status: "error"
    };
  }
}
export default async function CmsPageView(t0) {
  const $ = _c(25);
  const {
    slug,
    fallbackTitle,
    fallbackHtml
  } = t0;
  let banner;
  let bodyHtml;
  let title;
  let updatedLine;
  if ($[0] !== fallbackHtml || $[1] !== fallbackTitle || $[2] !== slug) {
    const result = await fetchPage(slug);
    updatedLine = null;
    banner = null;
    if (result.status === "ok") {
      title = result.page.title;
      bodyHtml = result.page.body_html;
      updatedLine = `Last updated ${new Date(result.page.updated_at).toLocaleDateString()}`;
    } else {
      if (result.status === "missing") {
        title = fallbackTitle;
        bodyHtml = fallbackHtml;
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            tone: "warn",
            text: "This page hasn't been customised in the dashboard yet \u2014 showing the default copy."
          };
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        banner = t1;
      } else {
        title = fallbackTitle;
        bodyHtml = fallbackHtml;
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            tone: "info",
            text: "Couldn't reach the live CMS right now \u2014 showing the default copy."
          };
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        banner = t1;
      }
    }
    $[0] = fallbackHtml;
    $[1] = fallbackTitle;
    $[2] = slug;
    $[3] = banner;
    $[4] = bodyHtml;
    $[5] = title;
    $[6] = updatedLine;
  } else {
    banner = $[3];
    bodyHtml = $[4];
    title = $[5];
    updatedLine = $[6];
  }
  let t1;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[var(--accent)]">Legal</p>;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== title) {
    t2 = <h1 className="text-4xl font-bold md:text-5xl">{title}</h1>;
    $[10] = title;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== updatedLine) {
    t3 = updatedLine ? <p className="text-sm text-[var(--subtle)]">{updatedLine}</p> : null;
    $[12] = updatedLine;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <header className="space-y-3">{t1}{t2}{t3}</header>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== banner) {
    t5 = banner ? <div role="status" className="mt-6 rounded-lg border px-4 py-3 text-sm" style={{
      borderColor: banner.tone === "warn" ? "rgba(255,193,7,0.4)" : "rgba(24,200,230,0.4)",
      background: banner.tone === "warn" ? "rgba(255,193,7,0.08)" : "rgba(24,200,230,0.08)",
      color: banner.tone === "warn" ? "#ffc107" : "var(--accent)"
    }}>{banner.text}</div> : null;
    $[17] = banner;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== bodyHtml) {
    t6 = <div className="cy-prose mt-10" dangerouslySetInnerHTML={{
      __html: bodyHtml
    }} />;
    $[19] = bodyHtml;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = <article className="mx-auto w-full max-w-6xl px-6 py-16">{t4}{t5}{t6}</article>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}